import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=2eb8bc7e"
import script from "./layout.vue?vue&type=script&setup=true&lang=js"
export * from "./layout.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb8bc7e')) {
      api.createRecord('2eb8bc7e', component.options)
    } else {
      api.reload('2eb8bc7e', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=2eb8bc7e", function () {
      api.rerender('2eb8bc7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/layout.vue"
export default component.exports